import { Component,Input } from '@angular/core';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  @Input() title?:string;
  isSidebarOpen$ = this.menuService.sidebarOpen$;

  constructor(private menuService: MenuService) {}

  toggleSidebar() {
    this.menuService.toggleSidebar(); // Llama al servicio para alternar el estado
  }

}
